import { v4 as uuid } from 'uuid';

import * as actionTypes from '../actions/paymentActionTypes';

import { clearManualCreditScore, updateCurrentCalculationEndpoint } from '../actions/creators';
import { calculatePayments, fakePaymentFailure } from '../actions/paymentActionCreators';
import * as types from '../types/actionTypes';
import { CALC_ENDPOINTS } from '../constants';
import type { IPaymentConfig, IStateTreeWithFeatureToggles, PaymentReduxAction } from '../types/paymentTypes';
import { withMeta } from '../utils/paymentUtils';
import { getCurrentOfferType, getFeatureToggle, getIsUserProgramQuotes } from '../selectors';
import { reconcileAfterShopperLocationChange, stampShopperLocationChange } from './locationChangeReconciliation';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';

export const paymentMiddleware = (middlewareConfig: IPaymentConfig) => (store: any) => (next: any) => (incomingAction: AnyFSA) => {
    const preActionState: IStateTreeWithFeatureToggles = store.getState();
    const action = stampShopperLocationChange(preActionState, incomingAction, middlewareConfig);

    if (action.type === types.SELECTED_CREDIT_TIER) {
        const isClearEnabled = getFeatureToggle(preActionState, 'clearManualCreditScoreOnTierSelect');
        const isAutoSelectActive = !getIsUserProgramQuotes(preActionState);
        if (isClearEnabled && isAutoSelectActive) {
            store.dispatch(clearManualCreditScore());
        }
    }

    next(action);

    reconcileAfterShopperLocationChange(store, action);

    const middleware = action?.meta?.middleware || {};
    const shouldExecute = Boolean(middleware.payment);
    const state: IStateTreeWithFeatureToggles = store.getState();
    const offerType = getCurrentOfferType(state);

    const isFnIDealMode = middlewareConfig?.selectors?.isFnIDealMode?.(state);
    if (action.type === types.UPDATED_OFFER_TYPE && isFnIDealMode && shouldExecute) {
        store.dispatch(updateCurrentCalculationEndpoint(CALC_ENDPOINTS.userProgramQuotes, offerType, { withPayment: false }));
    }

    if (!shouldExecute) {
        return;
    }

    store.dispatch(
        withMeta(
            {
                type: actionTypes.PAYMENT_REQUESTED,
                payload: {
                    actionType: action.type,
                    traceId: uuid()
                }
            },
            action
        )
    );

    if (middlewareConfig?.selectors?.shouldFakePaymentFailure?.(state)) {
        store.dispatch(fakePaymentFailure(action));
    } else {
        store.dispatch(calculatePayments(action as PaymentReduxAction, middlewareConfig));
    }
};
